import useReveal from "../../hooks/useReveal";

import "./about.scss";

export default function About() {
  const [ref, , cls] = useReveal({ threshold: 0.25 });
  return (
    <section className={`about ${cls}`} id="about" ref={ref}>
      <div className="about-window">
        <img
          src="/assets/Kareem_1.png"
          alt="Kareem Elewa in a candlelit cafe, looking out of a window strung with lights"
          width="910"
          height="1286"
          loading="lazy"
          draggable="false"
        />
      </div>
      <div className="about-text">
        <h2>Built to hold nearly 500,000 players at once.</h2>
        <p>
          I'm Kareem, a computer science student and game engineer. I co-founded
          Volleyball Legends and work on its backend: architecture, data
          systems, matchmaking, and live operations for a game with 124 million
          monthly players.
        </p>
        <p>
          At Amgen I built an AI research assistant for epidemiologists and
          the data pipelines behind it, cutting literature review turnaround by
          roughly 40%. Different field, same job: it has to stay up when
          traffic spikes.
        </p>
      </div>
    </section>
  );
}
